import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { deleteCookie } from "../../utils/saveCookies";
import { VALID_USER } from "./types/Validuser";
export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [Auth, setAuth] = useState(false);
  const [User, setUser] = useState({});
  const [role, setRole] = useState([]);
  const Navigate = useNavigate();
  useEffect(() => {
    // Recuperar el estado de autenticación de localStorage al cargar la página
    const storedUser = JSON.parse(sessionStorage.getItem('userData'));
    const auth = storedUser?.auth
    const role = storedUser?.role

    if (auth && storedUser) {
      setAuth(auth);
      setUser(storedUser);
      setRole(role)
    }
  }, []);

  const getRole = (role) => {
    setRole(role)
  }

  const signIn = (userData) => {
    sessionStorage.setItem("userData", JSON.stringify(userData));
    setUser(userData);
    setAuth(true);
  };

  const signOut = (e) => {
    sessionStorage.clear();
    deleteCookie("infopass")
    setAuth(false);
    Navigate("/login");
  };

  const checkAuthentication = () => {
    const dataUser = JSON.parse(sessionStorage.getItem('userData'));
    if (dataUser?.token) {
      const userRoles = Array.isArray(dataUser.role) ? dataUser.role : [dataUser.role]; 
      const isValidUser = userRoles.some(role => VALID_USER.includes(role));
      
      setIsAuthenticated(isValidUser);
      if (!isValidUser) {
        alert("No tienes permisos para acceder. Serás redirigido al login.");
        setIsAuthenticated(isValidUser);
      }
    } else {
      setIsAuthenticated(false);
    }
  };
  return {
    Auth,
    User,
    role,
    getRole,
    signIn,
    signOut,
    checkAuthentication,
    isAuthenticated
  }
};